const SITE = {
	url: "https://www.northwestwind.org",
	name: "North West Wind",
	title: "North West Wind | Digital Products, Data Engineering and Loyalty Systems",
	description:
		"North West Wind is Michele Maestrale's digital product studio for Swapstamp, data engineering, logistics technology and practical software solutions.",
	locale: "en_US",
	language: "en",
	image: "/homepage.jpg",
	author: {
		name: "Michele Maestrale",
		email: "michele.maestrale90@gmail.com",
		linkedin: "https://www.linkedin.com/in/michele-maestrale-3250b681/",
		github: "https://github.com/michele1990",
	},
};

export const absoluteUrl = (path = "/") => {
	if (/^https?:\/\//i.test(path)) {
		return path;
	}

	const normalizedPath = path.startsWith("/") ? path : `/${path}`;
	return `${SITE.url}${normalizedPath}`;
};

export default SITE;
